<button mat-button [type]="type" [class]="addClass + ' cy__btn'" [matTooltip]="iconOnly ? label : ''" (click)="action()" [disabled]="disabled">
    <i *ngIf="icon" [class]="icon"></i><span *ngIf="!iconOnly&&label">{{ label }}</span>
    <ng-content></ng-content>
</button>